import React, { Component } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import earthTexture from './images/earthTexture.jpeg';
import earthBumpMap from './images/earthBumpMap.jpeg';
import earthSpecMap from './images/earthSpecMap.jpeg';
import earthCloudTexture from './images/earthCloudTexture.png';

class ImprovedEarth extends Component {
    componentDidMount() {
        this.initScene();
        this.initCamera();
        this.initRenderer();
        this.initLights();
        this.initEarth();
        this.animate();
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animationFrameId);
        this.controls.dispose();
        this.mount.removeChild(this.renderer.domElement);
    }

    initScene = () => {
        this.scene = new THREE.Scene();
        // this.scene.background = new THREE.Color(0x000000); // 深色背景
        this.scene.background = null; // 深色背景
    };

    initCamera = () => {
        const { clientWidth, clientHeight } = this.mount;
        this.camera = new THREE.PerspectiveCamera(75, clientWidth / clientHeight, 0.1, 1000);
        this.camera.position.set(0, 0, 300);

        this.controls = new OrbitControls(this.camera, this.mount);
        this.controls.enableDamping = true; // 启用阻尼效果
        this.controls.dampingFactor = 0.1;
        this.controls.enableZoom = true; // 允许缩放
    };

    initRenderer = () => {
        const { clientWidth, clientHeight } = this.mount;
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true // 启用透明背景
        });
        this.renderer.setClearColor(0x000000, 0); // 设置背景颜色为黑色且完全透明
        this.renderer.setSize(clientWidth, clientHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.mount.appendChild(this.renderer.domElement);
    };

    initLights = () => {
        // 环境光
        const ambientLight = new THREE.AmbientLight(0x404040); // 柔和的白光
        this.scene.add(ambientLight);

        // 平行光
        const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
        directionalLight.position.set(5, 10, 7.5);
        this.scene.add(directionalLight);

        // 点光源
        const pointLight = new THREE.PointLight(0xffffff, 0.8);
        pointLight.position.set(0, 0, 200);
        this.scene.add(pointLight);
    };

    initEarth = () => {
        const earthGeometry = new THREE.SphereGeometry(170, 64, 64);

        // 地球材质
        const earthMaterial = new THREE.MeshPhongMaterial({
            map: new THREE.TextureLoader().load(earthTexture), // 地球纹理
            bumpMap: new THREE.TextureLoader().load(earthBumpMap), // 凹凸贴图
            bumpScale: 0.5,
            specularMap: new THREE.TextureLoader().load(earthSpecMap), // 高光贴图
            specular: new THREE.Color(0xaaaaaa),
            shininess: 10, // 高光强度
        });

        this.earth = new THREE.Mesh(earthGeometry, earthMaterial);
        this.scene.add(this.earth);

        // 云层材质
        const cloudGeometry = new THREE.SphereGeometry(172, 64, 64); // 略大于地球
        const cloudMaterial = new THREE.MeshPhongMaterial({
            map: new THREE.TextureLoader().load(earthCloudTexture), // 云层纹理
            transparent: true,
        });

        this.cloud = new THREE.Mesh(cloudGeometry, cloudMaterial);
        this.scene.add(this.cloud);
    };

    animate = () => {
        this.animationFrameId = requestAnimationFrame(this.animate);

        // 自转
        this.earth.rotation.y += 0.002;
        this.cloud.rotation.y += 0.004;

        // 渲染场景
        this.renderer.render(this.scene, this.camera);
        this.controls.update();
    };

    render() {
        return (
            <div
                ref={(mount) => { this.mount = mount; }}
                className="earth_container"
            />
        );
    }
}

export default ImprovedEarth;
